export const classNames = {
  SLIDER_CONTAINER: 'qvh24__recommendations-slider',
  SLIDER_WRAPPER: 'swiper-wrapper',
  SLIDER_SLIDE: 'swiper-slide',
  SLIDER_NAV_ARROW_LEFT: 'qvh24__recommendations-slider__nav-arrow-left',
  SLIDER_NAV_ARROW_RIGHT: 'qvh24__recommendations-slider__nav-arrow-right',
  IMAGE: 'qvh24__recommendations-slider__image',
  TITLE: 'qvh24__recommendations-slider__title',
  PRICE: 'qvh24__recommendations-slider__price',
  PRICE_VAL: 'qvh24__recommendations-slider__price-val',
  PRICE_VAL_NEW: 'qvh24__recommendations-slider__price-val-new',
  PRICE_VAL_OLD: 'qvh24__recommendations-slider__price-val-old',
  DELIVERY_TIME: 'qvh24__recommendations-slider__delivery-time',
  DELIVERY_TIME_FAST: 'qvh24__recommendations-slider__delivery-time--fast'
};

export const RECOMMENDATIONS_URL = {
  DY: 'sliders/quickview?type=dy',
  INHOUSE: 'sliders/quickview?type=inhouse'
};

export const AB_TEST_ATTR_NAME = 'data-recommendations-slider-ab-test-value';

export const AB_TEST_VALUE = {
  INHOUSE_SLIDER: 'a',
  DY_SLIDER: 'b'
};

const DY_SECTION_ID = {
  DEV: 8766762,
  STAGING: 8768293,
  PROD: 8766761
};

export const DY_STRATEGY_IDS = {
  [DY_SECTION_ID.DEV]: 48087,
  [DY_SECTION_ID.STAGING]: 48587,
  [DY_SECTION_ID.PROD]: 51761
};



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/components/quickview/constants/recommendations.js
 **/